export default {
	messages: {
		de: {
			street: 'Straße und Nummer',
			zipCode: 'PLZ',
			city: 'Ort',
			country: 'Land',

			noData: 'Keine Daten',
		},
		en: {
			street: 'Street and Number',
			zipCode: 'ZIP-Code',
			city: 'City',
			country: 'Country',

			noData: 'No data',
		},
	},
};
